import { useCallback } from 'react';
import { MemberType } from 'api/models';
import { useTranslate } from 'hooks/use-translation';
import { useAccountMetaQuery } from 'queries';

export const useResponsible = (): ((
  responsibilityFromApi?: string,
) => string) => {
  const { data: accountMeta, isLoading } = useAccountMetaQuery();
  const translate = useTranslate();
  const companyName = accountMeta?.company.companyName;
  const convertResponsibilityAsUI = useCallback(
    (responsibilityFromApi?: string) => {
      if (isLoading) {
        return responsibilityFromApi || '';
      }
      if (!responsibilityFromApi) {
        return '';
      }
      if (responsibilityFromApi === MemberType.Native && companyName) {
        return companyName;
      }
      if (responsibilityFromApi === MemberType.External) {
        return translate('customer');
      }

      return responsibilityFromApi;
    },
    [companyName, isLoading, translate],
  );

  return convertResponsibilityAsUI;
};
